const cs_django_links = {
    EXPORT_TERMS_AND_CONDITIONS: "/d/export/terms-and-conditions",
    EXPORT_PRIVACY_POLICY: "/d/export/privacy-policy",
}

export default cs_django_links
